import React from 'react';
import { useAuth } from '../context/AuthContext';

const OturumUyarisi = () => {
  const { oturumUyari, tokenYenile, cikisYap } = useAuth();
  
  if (!oturumUyari) return null;
  
  return (
    <div style={{
      position: 'fixed', top: '1rem', right: '1rem', zIndex: 9999,
      background: 'var(--sari)', color: '#000', borderRadius: 'var(--radius)',
      padding: '1rem 1.25rem', boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      maxWidth: '360px', border: '1px solid rgba(0,0,0,0.1)'
    }}>
      <p style={{ fontWeight: '600', marginBottom: '8px' }}>Oturum Suresi Doluyor</p>
      <p style={{ fontSize: '13px', marginBottom: '12px' }}>
        Oturumunuzun suresi 5 dakika icinde dolacak. Devam etmek istiyor musunuz?
      </p>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button className="btn btn-primary btn-sm" onClick={tokenYenile}>
          Devam Et
        </button>
        <button className="btn btn-secondary btn-sm" onClick={() => cikisYap()}>
          Cikis Yap
        </button>
      </div>
    </div>
  );
};

export default OturumUyarisi;
